export const dispatchCustomEvent = (event, detail) => {
	const customEvent = new CustomEvent(event, {detail});
	document.dispatchEvent(customEvent);
};